module.exports = __webpack_public_path__ + "img/info-dm.7a3b95bc.svg";